module.exports = __webpack_public_path__ + "assets/img/minus_icon.9a1ec57d.svg";